import type { IconoNav } from './nav';

function Trazo(props: { readonly children: React.ReactNode; readonly className?: string }): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={props.className ?? 'h-5 w-5 shrink-0'}
      aria-hidden
    >
      {props.children}
    </svg>
  );
}

const TRAZOS: Record<IconoNav, React.ReactNode> = {
  inicio: (
    <>
      <path d="M4 10.5 12 4l8 6.5" />
      <path d="M6 10v9h12v-9" />
    </>
  ),
  escanear: (
    <>
      <path d="M7 5H5v2" />
      <path d="M17 5h2v2" />
      <path d="M7 19H5v-2" />
      <path d="M19 17v2h-2" />
      <rect x="8" y="8" width="8" height="8" />
    </>
  ),
  operaciones: (
    <>
      <path d="M8 7h12" />
      <path d="M8 12h12" />
      <path d="M8 17h12" />
      <path d="M4 7h.01" />
      <path d="M4 12h.01" />
      <path d="M4 17h.01" />
    </>
  ),
  alquileres: (
    <>
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M4 10h16" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
    </>
  ),
  mantenimiento: (
    <path d="M14.5 6.5a4 4 0 0 0-5.7 5.6L4 16.9 7.1 20l4.8-4.8a4 4 0 0 0 5.6-5.7l-2.2 2.2-2.8-2.8z" />
  ),
  avisos: (
    <>
      <path d="M6 9a6 6 0 1 1 12 0c0 5 2 6 2 6H4s2-1 2-6" />
      <path d="M10 19a2 2 0 0 0 4 0" />
    </>
  ),
  activos: (
    <>
      <path d="M12 3 20 7.5v9L12 21 4 16.5v-9z" />
      <path d="M12 12 20 7.5" />
      <path d="M12 12v9" />
      <path d="M12 12 4 7.5" />
    </>
  ),
  qr: (
    <>
      <rect x="4" y="4" width="6" height="6" />
      <rect x="14" y="4" width="6" height="6" />
      <rect x="4" y="14" width="6" height="6" />
      <path d="M14 14h3" />
      <path d="M20 14v6h-6" />
      <path d="M14 20h.01" />
    </>
  ),
  maestros: (
    <path d="M4 7h7l2 2h7v10H4z" />
  ),
  reportes: (
    <>
      <path d="M6 18V10" />
      <path d="M12 18V6" />
      <path d="M18 18v-7" />
    </>
  ),
  importacion: (
    <>
      <path d="M12 4v10" />
      <path d="M8 10l4 4 4-4" />
      <path d="M5 18h14" />
    </>
  ),
  marca: (
    <path d="M12 21a7 7 0 0 0 7-7c0-5-7-11-7-11S5 9 5 14a7 7 0 0 0 7 7z" />
  ),
  almacenamiento: (
    <>
      <rect x="4" y="5" width="16" height="6" rx="1" />
      <rect x="4" y="13" width="16" height="6" rx="1" />
      <path d="M8 8h.01" />
      <path d="M8 16h.01" />
    </>
  ),
  auditoria: (
    <>
      <path d="M9 4h6l5 5v11H4V4z" />
      <path d="M14 4v6h6" />
      <path d="M8 13h8" />
      <path d="M8 17h5" />
    </>
  ),
  preferencias: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3v2" />
      <path d="M12 19v2" />
      <path d="M4.2 7l1.8 1" />
      <path d="M18 16l1.8 1" />
      <path d="M4.2 17l1.8-1" />
      <path d="M18 8l1.8-1" />
    </>
  ),
  operar: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v4l3 2" />
    </>
  ),
  inventario: (
    <>
      <path d="M12 3 20 7.5v9L12 21 4 16.5v-9z" />
      <path d="M12 12 20 7.5" />
      <path d="M12 12v9" />
    </>
  ),
  administracion: (
    <>
      <path d="M5 8h14" />
      <path d="M5 16h14" />
      <circle cx="9" cy="8" r="1.6" />
      <circle cx="15" cy="16" r="1.6" />
    </>
  ),
};

export function IconoNavMarca(props: { readonly nombre: IconoNav; readonly className?: string }): React.JSX.Element {
  return <Trazo {...(props.className ? { className: props.className } : {})}>{TRAZOS[props.nombre]}</Trazo>;
}

export function IconoChevron(props: { readonly abierto: boolean }): React.JSX.Element {
  return (
    <Trazo className={`h-3.5 w-3.5 shrink-0 transition-transform ${props.abierto ? 'rotate-180' : ''}`}>
      <path d="M6 9l6 6 6-6" />
    </Trazo>
  );
}

export function IconoPanel(props: { readonly compacto: boolean }): React.JSX.Element {
  return (
    <Trazo>
      {props.compacto ? <path d="M9 6l6 6-6 6" /> : <path d="M15 6l-6 6 6 6" />}
    </Trazo>
  );
}
